// extracted by mini-css-extract-plugin
export default {"container":"Projects_container__fI5az","title":"Projects_title__tLZeS","projects":"Projects_projects__ywIwg"};